import { render, staticRenderFns } from "./banners.vue?vue&type=template&id=f2b7f86a&scoped=true"
import script from "./banners.vue?vue&type=script&lang=ts"
export * from "./banners.vue?vue&type=script&lang=ts"
import style0 from "./banners.vue?vue&type=style&index=0&id=f2b7f86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b7f86a",
  null
  
)

export default component.exports